import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class SkillService extends Service {
	constructor(injector: Injector) {
		super("Skill", injector);
	}
}